var _rect, _rect2, _rect3, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOnline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 22,
    height: 14.6667,
    rx: 2,
    fill: "#33B4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 10.0833,
    width: 2.75,
    height: 1.83333,
    fill: "#E5F6FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.83398,
    y: 10.0833,
    width: 2.75,
    height: 1.83333,
    fill: "#E5F6FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.916,
    cy: 11,
    r: 5.5,
    fill: "#00529A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.166 11H20.666",
    stroke: "#E5F6FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.916 8.25L20.666 11L17.916 13.75",
    stroke: "#E5F6FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOnline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Online.caa0bec8.svg";
export { ForwardRef as ReactComponent };